<div class="page-content container">
    <div class="page-header">
      <h1 class="page-title text-primary-d2">
        Árbitros
        <small class="page-info text-secondary-d2">
          <i class="fa fa-angle-double-right text-80"></i>
          Jueces y mesas
        </small>
      </h1>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="bgc-primary-d1 text-white px-3 py-25">
          <div class="row">
            <div class="col-md-6 col-12">
              <span class="text-90">Lista de</span> Árbitros
            </div>
            <div class="col-md-6 col-12">
              <div class="columns columns-right btn-group float-right">
                <button *ngIf="aplicacion.puede_crear" title="Nuevo" (click)="crearNuevoArbitro()"
                        class="btn btn-outline-default btn-smd bgc-white btn-h-light-primary btn-a-outline-primary py-1" type="button">
                  <i class="fa fa-plus text-purple-d1"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="bootstrap-table bootstrap4">
          <div class="fixed-table-toolbar">
            <div class="row">
              <div class="col-12 col-md-7">
                <app-paginator-header [paginator]="this"></app-paginator-header>
                <div class="row mt-1">
                  <div class="col-md-3 col-12"><label>Tipo</label></div>
                  <div class="col-md-5 col-12">
                    <select [compareWith]="compararObjectos" class="form-control" name="tipo"
                            [(ngModel)]="filter.tipo" (change)="getSearch(text_search,null)">
                      <option [ngValue]="tipo" *ngFor="let tipo of filter.tipos">{{tipo.nombre}}</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-3 col-12"><label>Disciplina</label></div>
                  <div class="col-md-5 col-12">
                    <select [compareWith]="compararObjectos" class="form-control" name="disciplina"
                            [(ngModel)]="filter.disciplina" (change)="getSearch(text_search,null)">
                      <option [ngValue]="disciplina" *ngFor="let disciplina of filter.disciplinas">{{disciplina.nombre}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-5 p-0">
                <button (click)="getSearch(text_search,null)" class="btn btn-xs btn-app btn-primary my-1"
                        type="button" title="Buscar">
                  <i class="d-block h-4 fa fa fa-search text-150"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>

          <table *ngIf="arbitros.length>0" class="table text-dark-m2 text-95 table-bordered table-hover table-striped table-responsive">
            <thead class="bgc-white text-grey text-uppercase text-80">
              <tr>
                <th>N°</th>
                <th class="center">Código</th>
                <th class="center">Nombre</th>
                <th class="center">Tipo</th>
                <th class="center">Disciplina</th>
                <th class="center">C.I.</th>
                <th class="center">Teléfono</th>
                <th class="center">Usuario</th>
                <th class="center">Activo</th>
                <th style="text-align:center; width:110px" data-field="tools">
                  <div class="th-inner"><i class="fa fa-cog text-secondary-d1 text-130"></i></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let arbitro of arbitros; let i=index;" [ngClass]="{'arbitro-dado-baja':!arbitro.activo}">
                <td>{{(i+1)}}</td>
                <td>{{arbitro.codigo}}</td>
                <td><b>{{arbitro.persona.nombre_completo}}</b></td>
                <td>
                  <span class="badge-tipo-arbitro"
                        [ngClass]="{'mesa':arbitro.tipo && arbitro.tipo.nombre_corto=='TORARMES'}">
                    {{arbitro.tipo?arbitro.tipo.nombre:''}}
                  </span>
                </td>
                <td class="center">
                  <b *ngIf="arbitro.disciplina" [style.color]="colorClase(arbitro.disciplina)">
                    {{arbitro.disciplina.nombre}}
                  </b>
                  <!-- sin disciplina dirige cualquiera, por eso no es un dato faltante -->
                  <span *ngIf="!arbitro.disciplina" class="text-grey text-85">TODAS</span>
                </td>
                <td>{{arbitro.persona.ci}}</td>
                <td>{{arbitro.persona.telefono}}</td>
                <td>
                  <ng-container *ngIf="arbitro.persona.usuario">
                    <i class="fas fa-user-check text-success mr-1"></i>{{arbitro.persona.usuario.nombre_usuario}}
                    <span *ngIf="!arbitro.persona.usuario.activo" class="text-danger text-85">(inactivo)</span>
                  </ng-container>
                  <span *ngIf="!arbitro.persona.usuario" class="text-grey text-85">Sin usuario</span>
                </td>
                <td class="center">
                  <span *ngIf="arbitro.activo" class="badge badge-sm badge-success">ACTIVO</span>
                  <span *ngIf="!arbitro.activo" class="badge badge-sm badge-danger">INACTIVO</span>
                </td>
                <td style="text-align:center">
                  <div class="action-buttons">
                    <a *ngIf="aplicacion.puede_modificar" title="Modificar" href="javascript:void(0)"
                       (click)="modificarArbitro(arbitro)"
                       class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-success btn-a-outline-success btn-text-success">
                      <i class="fa fa-pencil-alt text-105"></i>
                    </a>
                    <!-- al que ya esta de baja se le vuelve a activar desde el formulario -->
                    <a *ngIf="aplicacion.puede_eliminar && arbitro.activo" title="Dar de baja" href="javascript:void(0)"
                       (click)="abrirPopupConfirmacionEliminacion(arbitro)"
                       class="btn radius-1 btn-sm btn-brc-tp btn-outline-default btn-h-outline-danger btn-a-outline-danger btn-text-danger">
                      <i class="fa fa-trash-alt text-105"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="arbitros.length==0" class="text-center text-grey py-4">
            No hay árbitros registrados.
          </div>
          <app-paginator-footer [paginator]="this"></app-paginator-footer>
        </div>
      </div>
    </div>
</div>

<ng-template #modal_arbitro let-modal>
    <div class="modal-header card-header">
        <div class="col-md-8 col-xs-8">
            <span class="text-blue text-125">{{arbitro.id?'Modificar':'Nuevo'}} Árbitro</span>
        </div>
        <div class="col-md-4 col-xs-4">
            <button class="btn btn-primary" type="button" (click)="guardarArbitro()">
                <i class="fa fa-save text-110 mr-1"></i>
            </button>&nbsp;
            <button class="btn btn-danger" type="button" (click)="modal.dismiss('Cross click')">
                <i class="fa fa-times red2 text-110 mr-1"></i>
            </button>
        </div>
    </div>
    <div class="modal-body card-body">
      <div class="row">
        <div class="col-md-4"><label>Código</label>
          <input type="text" name="codigo" [(ngModel)]="arbitro.codigo" class="form-control" placeholder="Código" />
        </div>
        <div class="col-md-5"><label>Tipo</label>
          <select [compareWith]="compararObjectos" class="form-control" name="tipo" [(ngModel)]="arbitro.tipo">
            <option [ngValue]="tipo" *ngFor="let tipo of tipo_arbitro.clases">{{tipo.nombre}}</option>
          </select>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-9"><label>Disciplina</label>
          <select [compareWith]="compararObjectos" class="form-control" name="disciplina" [(ngModel)]="arbitro.disciplina">
            <option [ngValue]="null">TODAS LAS DISCIPLINAS</option>
            <option [ngValue]="disciplina" *ngFor="let disciplina of tipo_disciplina.clases">{{disciplina.nombre}}</option>
          </select>
          <div class="text-grey text-90">El fixture solo le asigna partidos de su disciplina</div>
        </div>
        <!-- solo los activos entran en el sorteo de arbitros del fixture -->
        <div class="col-md-3"><label>Activo</label><br>
          <label class="py-0">
            <input type="checkbox" [(ngModel)]="arbitro.activo" name="arbitro_activo" class="align-middle mr-1" />
            <span class="text-90">{{arbitro.activo?'Disponible':'Dado de baja'}}</span>
          </label>
        </div>
      </div>
      <div class="row" *ngIf="!arbitro.activo">
        <div class="col-12 text-danger text-90">
          <i class="fa fa-exclamation-triangle mr-1"></i>
          Estando de baja no se le asignarán partidos al generar el fixture.
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-4"><label>Nombres</label>
          <input type="text" name="nombres" [(ngModel)]="arbitro.persona.nombres" class="form-control" required />
        </div>
        <div class="col-md-4"><label>Apellido paterno</label>
          <input type="text" name="ap" [(ngModel)]="arbitro.persona.apellido_paterno" class="form-control" required />
        </div>
        <div class="col-md-4"><label>Apellido materno</label>
          <input type="text" name="am" [(ngModel)]="arbitro.persona.apellido_materno" class="form-control" />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4"><label>C.I.</label>
          <input type="text" name="ci" [(ngModel)]="arbitro.persona.ci" class="form-control" />
        </div>
        <div class="col-md-4"><label>Teléfono</label>
          <input type="text" name="telefono" [(ngModel)]="arbitro.persona.telefono" class="form-control" />
        </div>
        <div class="col-md-4"><label>Correo</label>
          <input type="email" name="correo" [(ngModel)]="arbitro.persona.correo_electronico" class="form-control" />
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <label class="mb-0">
            <input type="checkbox" [(ngModel)]="arbitro.tiene_usuario" name="tiene_usuario" class="align-middle mr-1" />
            <b>Puede ingresar al sistema</b>
          </label>
          <div class="text-grey text-90">Le crea o modifica el usuario con el que inicia sesión</div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="arbitro.tiene_usuario">
        <div class="col-md-5"><label>Nombre de usuario</label>
          <input type="text" name="nombre_usuario" [(ngModel)]="arbitro.usuario.nombre_usuario" class="form-control" />
        </div>
        <div class="col-md-4"><label>Clave</label>
          <input type="password" name="clave" [(ngModel)]="arbitro.usuario.clave" class="form-control"
                 [placeholder]="arbitro.id?'Dejar vacío para no cambiarla':'Clave'" autocomplete="new-password" />
        </div>
        <div class="col-md-3">
          <label>Usuario activo</label><br>
          <label class="py-0">
            <input type="checkbox" [(ngModel)]="arbitro.usuario.activo" name="usuario_activo" class="align-middle mr-1" />
            <span class="text-90">Puede iniciar sesión</span>
          </label>
        </div>
      </div>
    </div>
</ng-template>
